export const VIEWS = ["list", "calendar", "map"];

export const FILTER_KEYS = ["region", "type", "theme", "month", "access", "closing", "q", "country"];

export function fmtRange(start, end) {
  if (!start) return "Dates to be announced";
  const opts = { month: "short", day: "numeric" };
  const s = new Date(start + "T00:00:00");
  if (!end || end === start) return s.toLocaleDateString("en-US", { ...opts, year: "numeric" });
  const e = new Date(end + "T00:00:00");
  const sameMonth = s.getMonth() === e.getMonth() && s.getFullYear() === e.getFullYear();
  if (sameMonth) return `${s.toLocaleDateString("en-US", { month: "short" })} ${s.getDate()}–${e.getDate()}, ${e.getFullYear()}`;
  return `${s.toLocaleDateString("en-US", opts)} – ${e.toLocaleDateString("en-US", { ...opts, year: "numeric" })}`;
}

export function monthLabel(ym) {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-US", { month: "long", year: "numeric" });
}

export function monthKey(d) {
  return d.slice(0, 7);
}

export function shiftMonth(ym, delta) {
  const [y, m] = ym.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function todayYm() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function initials(name) {
  return (name || "")
    .replace(/\(.*?\)/g, "")
    .split(/[\s—–-]+/)
    .filter((w) => /^[A-Za-z]/.test(w) && !/^(the|of|and|de|del|la|le)$/i.test(w))
    .slice(0, 3)
    .map((w) => w[0].toUpperCase())
    .join("");
}

export function daysBetween(a, b) {
  return Math.round((new Date(b + "T00:00:00") - new Date(a + "T00:00:00")) / 86400000);
}

/** events starting within ±7 days of `ev` (excluding itself) */
export function sameWeekCount(ev, all) {
  if (!ev.start_date) return 0;
  return all.filter((o) => o.id !== ev.id && o.start_date && Math.abs(daysBetween(ev.start_date, o.start_date)) <= 7).length;
}

export function readFilters(searchParams) {
  const f = {};
  for (const k of FILTER_KEYS) {
    const v = searchParams.get(k);
    if (v) f[k] = v;
  }
  return f;
}

export function eventSeoDescription(ev) {
  const where = [ev.venue, ev.city, ev.country].filter(Boolean).join(", ");
  return `${ev.name} — ${ev.event_type_label}${where ? ` in ${where}` : ""}, ${fmtRange(ev.start_date, ev.end_date)}. Official dates, access type and why it matters for DMOs, hotels and travel tech.`;
}

/** hostname without www. — "" for malformed URLs (never throws) */
export function hostOf(url) {
  try { return new URL(url).hostname.replace(/^www\./, ""); } catch { return ""; }
}

/** schema.org Organization for the organiser — null when nothing usable */
export function organizerLd(ev) {
  const name = ev.organiser || hostOf(ev.official_url);
  if (!name) return null;
  return { "@type": "Organization", name, ...(ev.official_url ? { url: ev.official_url } : {}) };
}
